export default __webpack_public_path__ + "static/media/adam.65fc5834.jpg";